module.exports = __webpack_public_path__ + "img/tang-orange.44fa4699.jpg";